<template>
    <yxt-date-picker
      prefix-icon="yxt-icon-date"
      v-model="getValue"
      :default-time="defaultTime"
      type="datetime"
      format="yyyy-MM-dd HH:mm"
      :picker-options="pickerOptions"
      :placeholder="$t('pc_biz_chooseDate' /* 选择日期时间 */)"
      :focus="onFocus"
      :clearable="false"
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    >
    </yxt-date-picker>
</template>
<script>
export default {
  name: 'LiveBegintime',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', new Date(val));
      }
    }
  },
  created() {
    this.onFocus();
  },
  data() {
    return {
      defaultTime: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      }
    };
  },
  methods: {
    onFocus() {
      // todo
      const minutes = new Date().getMinutes();
      let time = 0;
      if (minutes === 0 && minutes === 30) {
        time = parseInt(new Date().getTime() / 60000, 10) * 60000;
      } else {
        let date = (new Date().getTime() + (30 - (minutes % 30)) * 60 * 1000) / 60000;
        time = parseInt(date, 10) * 60000;
      }
      this.$emit('input', new Date(time));
      this.defaultTime = `${new Date(time).getHours()}:${new Date(
        time,
      ).getMinutes()}:00`;
    }
  }
};
</script>
<style scoped lang="less"></style>
